import { CompanyLicenseType } from "../type/company-license-type";
import { OsType } from "../type/os-type";

export class Company {

  id: string;
  name: string;
  ipAddress: string;
  apiKey: string;
  address: string;
  email: string;
  phone: string;
  createdBy: string;
  created: Date;
  modifiedBy: string;
  modified: Date;
  deleted: Date;
  clientCnt: number;
  licenseType: CompanyLicenseType;
  manager: string;
  mdbVersion: string;
  serverVersion: string;
  useFontLicense: boolean;
  fontProductCnt: number;
  agreementVersion: number;
  usePatchDb: boolean = true;
  latestClientVersion: string;
  usePatchDeploy: boolean = true;
  viewSuffix: string;
  ccParent: boolean = false;
  mdbOsType: OsType = OsType.WINDOWS;
  allowServerAutoUpdate: boolean = true;
  allowClientAutoUpdate: boolean = true;
  agreementRev: number;
  keypairId: string;
  allowMaintenanceReport: boolean = true;

  constructor(obj?: any) {
    const company = obj || {};
    Object.assign(this, company);
    this.created = company.created ? new Date(company.created) : null;
    this.modified = company.modified ? new Date(company.modified) : null;
    this.deleted = company.deleted ? new Date(company.deleted) : null;
  }

}
